<template>
  <chart class="qj-echarts" ref="chart" :options="options"></chart>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultOptions: {
        series: [
          {
            type: "treemap",
            data: [
              {
                name: "nodeA",
                value: 10,
                children: [
                  {
                    name: "nodeAa",
                    value: 4,
                  },
                  {
                    name: "nodeAb",
                    value: 6,
                  },
                ],
              },
              {
                name: "nodeB",
                value: 20,
                children: [
                  {
                    name: "nodeBa",
                    value: 20,
                    children: [
                      {
                        name: "nodeBa1",
                        value: 20,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    };
  },
  computed: {
    options() {
      if (!this.data) return this.defaultOptions;
      return this.renderChart();
    },
  },
  methods: {
    renderChart() {
      let options = { ...this.defaultOptions };
      return options;
    },
  },
};
</script>

<style></style>
